<template>
  <div class="overflow-hidden">
    <Transition
      mode="out-in"
      name="fade"
    >
      <div
        v-if="path !== ''"
        class="h-100"
        :style="{
          backgroundImage: 'url(' + path + ')',
          backgroundSize: backgroundSize,
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }"
      ></div>
      <div
        v-else
        class="h-100"
        :style="{
          backgroundImage: 'url(no-image.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }"
      ></div>
    </Transition>
  </div>
</template>

<script>
  import {storage} from "../../plugins/firebase";
  import {ref as storageRef, getBlob} from "firebase/storage";

  export default {
    name: "imageBlob",
    data() {
      return {
        path: "",
      };
    },
    props: {
      imagePath: String,
      backgroundSize: {
        type: String,
        default: "cover",
      },
    },
    methods: {
      getImage(path) {
        console.log("Fetching image from path:", path);
        return getBlob(storageRef(storage, path))
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            console.log("Image fetched successfully:", url);
            return url;
          })
          .catch((err) => {
            console.log(err);
            return "";
          });
      },
    },
    watch: {
      async imagePath(newPath) {
        console.log("imagePath prop changed to:", newPath);
        if (newPath) {
          this.path = await this.getImage(newPath);
        } else {
          this.path = "";
          console.log("Image path cleared.");
        }
      },
    },
    async mounted() {
      console.log("mounted ImgaeBlob");
      if (this.imagePath) {
        this.path = await this.getImage(this.imagePath);
        console.log("Image path set to:", this.path);
      }
    },
  };
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
